import styles from './pagination2.module.css'
import { Icon } from '../icon/icon'

type Props = {
    currentPage: number
    showNext?: boolean
    onGoToPreviousPage: () => void
    onGoToNextPage: () => void
    className?: string
}

export const Pagination = (props: Props) => {
    const { currentPage, showNext, onGoToPreviousPage, onGoToNextPage, className } = props

    return (
        <div className={`${styles.container} ${className || ''}`}>
            <Icon
                icon='arrow-left-circle'
                color='tertiary'
                onClick={onGoToPreviousPage}
                className={currentPage === 1 ? styles.hidden : ''}
            />
            <span className={styles.pageNumber}>{currentPage}</span>
            <Icon
                icon='arrow-right-circle'
                color='tertiary'
                onClick={onGoToNextPage}
                className={!showNext ? styles.hidden : ''}
            />
        </div>
    )
}
